import DraftTimesheetLogLayout from "../../layout";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import { COLUMNS, DEFAULT_FILTERS, FIELDS, TITLE } from "./constants";
import { TIMESHEET_DRAFT_DAY_VIEW } from "@/lib/utils";
import List from "components/list";

export default function DraftTimesheetLogTable() {

  return (
    <DraftTimesheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      <List
        title=""
        storageKey="timesheet-draft-log"
        filters={DEFAULT_FILTERS}
        endPoint="draft_timesheet"
        showSearch={false}
        columns={COLUMNS}
        sortBy="date_created"
        sortOrder="desc"
        // teleportFilterButton={true}
        meta={{
          fields: FIELDS,
        }}
        // renderFilters={TimesheetFilters}
        href={(item) => `/${TIMESHEET_DRAFT_DAY_VIEW}/${item.id}`}
      />
    </DraftTimesheetLogLayout>
  );
}
